<template>
     <div class="homeWrap">
         <!--banner图-->
         <div class="banner-wrap">
              <div class="img"></div>
         </div>
         <!---->
         <div class="homePage-item">

            <!--新闻中心-->
            <div class="pageCon white">
                <div class="main">
                     <div class="topTibar clearfix">
                         <div class="tibar">
                               <h2>新闻中心</h2>
                               <span>News center</span>
                         </div>
                         <div class="tab-nav">
                            <ul>
                               <li><a href="javascript:void(0);" :class="[tab_news==1?'curr':'']" @click="switchTabnews(1)">行业政策</a></li>
                               <li><a href="javascript:void(0);" :class="[tab_news==2?'curr':'']" @click="switchTabnews(2)">行业动态</a></li>
                            </ul>
                         </div>
                     </div>
                     
                     <template v-if="tab_news==1">
                           <HomeNews  :id="4" />
                            <div class="viewmore">
                            <router-link :to="{ name: 'newslist',params:{id:4} }"><span>查看更多</span></router-link>
                     </div>
                     </template>

                     <template v-if="tab_news==2">
                           <HomeNews  :id="5" />
                            <div class="viewmore">
                            <router-link :to="{ name: 'newslist',params:{id:5} }"><span>查看更多</span></router-link>
                     </div>
                     </template>

                     
                    
                </div>
            </div>
            <!---->
            
            <!--供需对接-->
            <div class="pageCon ash">
               <div class="main">
                   <div class="topTibar clearfix">
                         <div class="tibar">
                               <h2>供需对接</h2>
                               <span>Supply and demand docking</span>
                         </div>
                         <div class="tab-nav">
                            <ul>
                               <li><a href="javascript:void(0);" :class="[tab_demand==1?'curr':'']" @click="switchTademand(1)">新材料展厅</a></li>
                               <li><a href="javascript:void(0);" :class="[tab_demand==2?'curr':'']" @click="switchTademand(2)">供方大厅</a></li>
                               <li><a href="javascript:void(0);" :class="[tab_demand==3?'curr':'']" @click="switchTademand(3)">需方大厅</a></li>
                            </ul>
                         </div>
                     </div>


                     <template v-if="tab_demand==1">
                          <HomeCmf />
                     </template>

                     <template v-if="tab_demand==2">
                           <HomeSupply />
                     </template>

                     <template v-if="tab_demand==3">
                           <HomeDemand />
                     </template>

               </div>
            </div>
            <!---->

            <!--协会服务-->
            <div class="pageCon white">
                <div class="main">
                     <div class="topTibar clearfix">
                         <div class="tibar">
                               <h2>协会服务</h2>
                               <span>Association of service</span>
                         </div>
                     </div>
                         <div class="homeSerShow clearfix">
                             <ul>
                                <li>
                                   <router-link :to="{ path: '/Subplatform/SubPlatformList'}" >
                                       <img class="pic-1" src="../assets/images/association_1.png" alt="">
                                       <img class="pic-2" src="../assets/images/association_1_1.png" alt="">
                                   </router-link>
                                </li>
                                 <li>
                                    <router-link :to="{ path: '/Subplatform/SubPlatformList?cid1=4&cid2=8'}" >
                                      <img class="pic-1" src="../assets/images/association_2.png" alt="">
                                      <img class="pic-2" src="../assets/images/association_2_1.png" alt="">
                                    </router-link>
                                </li>
                                 <li>
                                    <router-link :to="{ path: '/Subplatform/SubPlatformList?cid1=6'}" >
                                       <img class="pic-1" src="../assets/images/association_3.png" alt="">
                                       <img class="pic-2" src="../assets/images/association_3_1.png" alt="">
                                    </router-link>
                                </li>
                                 <li>
                                    <router-link :to="{ path: '/Subplatform/SubPlatformList?cid1=6&cid2=11'}" >
                                        <img class="pic-1" src="../assets/images/association_4.png" alt="">
                                       <img class="pic-2" src="../assets/images/association_4_1.png" alt="">
                                    </router-link>
                                </li>
                                 <li>
                                   <router-link :to="{ path: '/Subplatform/SubPlatformList?cid1=6&cid2=12'}" >
                                       <img class="pic-1" src="../assets/images/association_5.png" alt="">
                                       <img class="pic-2" src="../assets/images/association_5_1.png" alt="">
                                   </router-link>
                                </li>
                                 <li>
                                    <router-link :to="{ path: '/Subplatform/SubPlatformList?cid1=6&cid2=13'}" >
                                        <img class="pic-1" src="../assets/images/association_6.png" alt="">
                                       <img class="pic-2" src="../assets/images/association_6_1.png" alt="">
                                    </router-link>
                                </li>
                                 <li>
                                  <router-link :to="{ path: '/Subplatform/SubPlatformList?cid1=6&cid2=14'}" >
                                        <img class="pic-1" src="../assets/images/association_7.png" alt="">
                                       <img class="pic-2" src="../assets/images/association_7_1.png" alt="">
                                  </router-link>
                                </li>
                                 <li>
                                   <router-link :to="{ path: '/Subplatform/SubPlatformList?cid1=16&cid2=19'}" >
                                        <img class="pic-1" src="../assets/images/association_8.png" alt="">
                                       <img class="pic-2" src="../assets/images/association_8_1.png" alt="">
                                   </router-link>
                                </li>
                             </ul>
                         </div>
                     </div>
            </div>
            <!---->

            <HomeActivity :ListType="1" class="ash"></HomeActivity>

            <HomeActivity :ListType="2" class="white"></HomeActivity>
              <!--科学普及-->
              <!-- <div class="pageCon white">
                  <div class="main">
                       <div class="topTibar clearfix">
                         <div class="tibar">
                               <h2>科学普及</h2>
                               <span>Science popularization</span>
                         </div>
                     </div>
                     <div class="videoList clearfix">
                        <ul>
                           <li>
                             <a href="javascript:void(0);" @click="poptips">
                                  <div class="img">
                                    <img src="http://m.xincailiao.com/upload/202208/12/2022081214123696580.jpg" alt="">
                                    <span class="label">新材料</span>
                                  </div>
                                  <div class="info">
                                      <div class="name">2022全球超宽带高峰论坛宽带高峰 论坛宽带高峰论坛</div>
                                      <div class="userinfo clearfix">
                                           <div class="v_num">视频<span>4</span></div>
                                           <div class="user">
                                              <img src="http://m.xincailiao.com/images/user_avatar.png" alt="">
                                              <span>中国深圳</span>
                                           </div>
                                      </div>
                                  </div>
                              </a>
                           </li>
                           <li>
                               <a href="javascript:void(0);" @click="poptips">
                                  <div class="img">
                                    <img src="http://m.xincailiao.com/upload/202208/12/2022081214123696580.jpg" alt="">
                                    <span class="label">新材料</span>
                                  </div>
                                  <div class="info">
                                      <div class="name">2022全球超宽带高峰论坛宽带高峰 论坛宽带高峰论坛</div>
                                      <div class="userinfo clearfix">
                                           <div class="v_num">视频<span>4</span></div>
                                           <div class="user">
                                              <img src="http://m.xincailiao.com/images/user_avatar.png" alt="">
                                              <span>中国深圳</span>
                                           </div>
                                      </div>
                                  </div>
                              </a>
                           </li>
                           <li>
                            <a href="javascript:void(0);" @click="poptips">
                                  <div class="img">
                                    <img src="http://m.xincailiao.com/upload/202208/12/2022081214123696580.jpg" alt="">
                                    <span class="label">新材料</span>
                                  </div>
                                  <div class="info">
                                      <div class="name">2022全球超宽带高峰论坛宽带高峰 论坛宽带高峰论坛</div>
                                      <div class="userinfo clearfix">
                                           <div class="v_num">视频<span>4</span></div>
                                           <div class="user">
                                              <img src="http://m.xincailiao.com/images/user_avatar.png" alt="">
                                              <span>中国深圳</span>
                                           </div>
                                      </div>
                                  </div>
                              </a>
                           </li>
                           <li>
                             <a href="javascript:void(0);" @click="poptips">
                                  <div class="img">
                                    <img src="http://m.xincailiao.com/upload/202208/12/2022081214123696580.jpg" alt="">
                                    <span class="label">新材料</span>
                                  </div>
                                  <div class="info">
                                      <div class="name">2022全球超宽带高峰论坛宽带高峰 论坛宽带高峰论坛</div>
                                      <div class="userinfo clearfix">
                                           <div class="v_num">视频<span>4</span></div>
                                           <div class="user">
                                              <img src="http://m.xincailiao.com/images/user_avatar.png" alt="">
                                              <span>中国深圳</span>
                                           </div>
                                      </div>
                                  </div>
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="viewmore">
                        <a href="javascript:void(0);"  @click="poptips"><span>查看更多</span></a>
                    </div>
                  </div>
              </div> -->
              <!---->

         </div>
     </div>
</template>

<script>
import HomeNews from '../components/Common/HomeNews'
import HomeCmf from '../components/Common/HomeCmf'
import HomeSupply from '../components/Common/HomeSupply'
import HomeDemand from '../components/Common/HomeDemand'
import HomeActivity from '../components/Common/HomeActivity.vue';
import { Toast } from "vant";
export default {
	data(){return{
      tab_news:1,
      tab_demand:1,
    }},
    components:{
      HomeNews,
      HomeCmf,
      HomeSupply,
      HomeDemand,
      HomeActivity
    },
    mounted: function () {
       
    },
    created(){
    },
    methods:{
      switchTabnews: function (_type) {
         this.tab_news = _type;
      },
      switchTademand: function (_type) {
         this.tab_demand = _type;
      },
        poptips : function () {
            setTimeout(function () {
                Toast({ message: "功能开发中~敬请期待" })
            }, 500);
        },
    }   
}
</script>

<style>

</style>